import {
    Button,
    DataTable,
    DataTableCell,
    DataTableCustomComponent,
    DataTableRow,
    IconPlus,
    Page,
    Pill
} from '@7shifts/sous-chef';
import { __ } from 'i18n/translate';
import { Company, FeatureFlag } from 'adminPanel/types';
import { useCompanyFeatureFlags } from '../hooks/useCompanyFeatureFlags';
import AddCompanyFeature from '../components/AddCompanyFeatureModal/AddCompanyFeatureModal';
import { useState } from 'react';
import DeleteCompanyFeatureModal from '../components/DeleteCompanyFeatureModal/DeleteCompanyFeatureModal';
import { useParams } from 'react-router-dom';

type Props = {
    company: Company;
};
const CompanyFeatureFlagsPage = ({ company }: Props) => {
    const [isAddFFModalOpen, setIsAddFFModalOpen] = useState(false);
    const { featureFlags, isLoading, refetch } = useCompanyFeatureFlags(
        company.id
    );
    return (
        <Page
            title={__('adminpanel.featureFlags')}
            breadcrumbs={{ label: __('adminpanel.companies'), url: '../../' }}
            actions={
                <Button
                    theme="primary"
                    onClick={() => setIsAddFFModalOpen(true)}
                >
                    <IconPlus size="medium" />
                    {__('adminpanel.addFeatureFlag')}
                </Button>
            }
        >
            <DataTable
                items={featureFlags}
                isLoading={isLoading}
                itemComponent={(props) => (
                    <FeatureFlagRow {...props} refetch={refetch} />
                )}
                columns={[
                    {
                        name: 'id',
                        label: '#ID',
                        size: 0.2
                    },
                    {
                        name: 'key',
                        label: 'Feature',
                        size: 2
                    },
                    {
                        name: 'isEnabled',
                        label: 'Status',
                        size: 1
                    }
                ]}
                showActionMenu
            />
            {isAddFFModalOpen && (
                <AddCompanyFeature
                    onClose={() => setIsAddFFModalOpen(false)}
                    onSuccess={refetch}
                    assignedFeatures={featureFlags}
                    companyId={company.id}
                />
            )}
        </Page>
    );
};

type FeatureFlagRowProps = DataTableCustomComponent<FeatureFlag> & {
    refetch: () => void;
};
const FeatureFlagRow = ({ item, refetch }: FeatureFlagRowProps) => {
    const params = useParams();
    const companyId = params.companyId as string;
    const [isDeleting, setIsDeleting] = useState(false);
    return (
        <>
            <DataTableRow
                actions={[
                    {
                        action: 'remove',
                        label: __('main.delete'),
                        onAction: () => {
                            setIsDeleting(true);
                        }
                    }
                ]}
            >
                <DataTableCell columnIndex={0}>{item.id}</DataTableCell>
                <DataTableCell columnIndex={1}>{item.key}</DataTableCell>
                <DataTableCell columnIndex={2}>
                    {item.enabled ? (
                        <Pill theme="success">{__('adminpanel.active')}</Pill>
                    ) : (
                        <Pill theme="danger">{__('adminpanel.inactive')}</Pill>
                    )}
                </DataTableCell>
            </DataTableRow>
            {isDeleting && (
                <DeleteCompanyFeatureModal
                    companyId={+companyId}
                    featureId={item.id}
                    onClose={() => setIsDeleting(false)}
                    onSuccess={refetch}
                />
            )}
        </>
    );
};

export default CompanyFeatureFlagsPage;
